import React from 'react';
import { Sparkles, Edit3, TrendingUp } from 'lucide-react';
import Logo from './Logo';
import NavigationButton from './NavigationButton';
import UserProfile from './UserProfile';

type DashboardPage = 'your-echoo' | 'build-story' | 'insights';

interface DashboardNavigationProps {
    currentPage: DashboardPage;
    onPageChange: (page: DashboardPage) => void;
    userEmail?: string;
    onSignOut: () => void;
    primaryColor?: string;
    hasIncompleteSetup?: boolean;
}

const DashboardNavigation: React.FC<DashboardNavigationProps> = ({
    currentPage,
    onPageChange,
    userEmail,
    onSignOut,
    primaryColor,
    hasIncompleteSetup = false
}) => {
    return (
        <div className="w-64 h-screen">
            <nav className="rounded-2xl fixed py-8 h-full flex flex-col">
                {/* Logo */}
                <div className="mx-2">
                    <Logo />
                </div>

                {/* Navigation Links - Takes up available space */}
                <div className="flex-1 space-y-3 mt-8">
                    <NavigationButton
                        icon={Sparkles}
                        label="Your Echoo"
                        isActive={currentPage === 'your-echoo'}
                        onClick={() => onPageChange('your-echoo')}
                        isPrimary={true}
                    />
                    <NavigationButton
                        icon={Edit3}
                        label="Build Your Story"
                        isActive={currentPage === 'build-story'}
                        onClick={() => onPageChange('build-story')}
                        hasAlert={hasIncompleteSetup}
                    />
                    <NavigationButton
                        icon={TrendingUp}
                        label="Insights"
                        isActive={currentPage === 'insights'}
                        onClick={() => onPageChange('insights')}
                        isSecondary={true}
                    />
                </div>

                {/* User Profile - Fixed at bottom */}
                <UserProfile
                    userEmail={userEmail}
                    primaryColor={primaryColor}
                    onSignOut={onSignOut}
                />
            </nav>
        </div>
    );
};

export default DashboardNavigation;
